import { render, staticRenderFns } from "./LeftNavbarComponent.vue?vue&type=template&id=50a40212&"
import script from "./LeftNavbarComponent.vue?vue&type=script&lang=js&"
export * from "./LeftNavbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavbarComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports